<nav class="nav-pagination">
    <div class="info-pagination">
        {{ getFirstNumber() }} - {{ getLastNumber() }} {{ 'CHECK.OF' | translate }} {{ totalPages === 1 ? listLength : totalItems }}
    </div>
    <ul class="pagination">
        <li class="page-item">
            <button class="page-link prev" aria-label="First" [ngClass]=" { 'disabled' : page  === 1 }" (click)="goToPage(1)">
                <img src="assets/icons/lastPageOutlined.svg" />
            </button>
        </li>

        <li class="page-item">
            <button class="page-link prev" aria-label="Previous" [ngClass]=" { 'disabled' : page  === 1 }" (click)="goToPage(page-1)">
                <img src="assets/icons/navigateNextOutlined.svg" />
            </button>
        </li>

        <li class="page-item page-info">
            <div class="page-link">{{ page }}</div>
        </li>

        <li class="page-item">
            <button class="page-link" aria-label="Next" [ngClass]=" { 'disabled' : page === totalPages }" (click)="goToPage(page+1)">
                <img src="assets/icons/navigateNextOutlined.svg" />
            </button>
        </li>

        <li class="page-item">
            <button class="page-link" aria-label="Last" [ngClass]=" { 'disabled' : page === totalPages }" (click)="goToPage(totalPages)">
                <img src="assets/icons/lastPageOutlined.svg" />
            </button>
        </li>
    </ul>
</nav>